import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import LoadingButton from '@mui/lab/LoadingButton';
import StudentAvatarView from '../../shared/StudentAvatarView';
import './TeacherStudentCard.css';

export function TeacherStudentGrid({ children, label, busy = false }) {
  return <Box className="teacher-student-grid-container">
    <Box className="teacher-student-grid" aria-label={label} aria-busy={busy}>{children}</Box>
  </Box>;
}

export function TeacherStudentAction({ loading = false, fullWidth = true, className = '', startIcon, children, ...props }) {
  return <LoadingButton aria-label={!startIcon && typeof children === 'string' ? children : undefined} {...props}
    startIcon={startIcon} fullWidth={fullWidth} loading={loading} loadingPosition={startIcon ? 'start' : 'center'} aria-busy={loading || undefined}
    loadingIndicator={<CircularProgress size={16} color="inherit" aria-label="Kaydediliyor" />}
    className={`teacher-student-action ${className}${!startIcon ? ' teacher-student-action--iconless' : ''}${loading ? ' teacher-student-action--loading' : ''}`}>
    <span className="teacher-student-action__label">{children}</span>
  </LoadingButton>;
}

export default function TeacherStudentCard({ studentId, name, avatarId, starterEmoji,
  statusLabel, tone = 'neutral', ariaLabel = name, identityAction, identityDetails, avatarOverlay,
  actions, actionColumns, actionsLabel, busy, children }) {
  return <article className={`teacher-student-card teacher-student-card--${tone}`} aria-label={ariaLabel} aria-busy={busy}>
    <Box className="teacher-student-card__identity">
      <Box className="teacher-student-card__avatar">
        <StudentAvatarView studentId={studentId} avatarId={avatarId} starterEmoji={starterEmoji} name={name} size={72}
          sx={{ fontSize: 60, lineHeight: 1, '& img': { width: '85%', height: '85%', objectFit: 'contain', p: 0 } }} />
        {avatarOverlay}
      </Box>
      <Box className="teacher-student-card__name">
        <Typography component="h2">{name}</Typography>
        <span className={`teacher-student-card__status teacher-student-card__status--${tone}`}>{statusLabel}</span>
        {identityDetails}
      </Box>
      {identityAction}
    </Box>
    {actions && <Box className="teacher-student-card__actions" role="group" aria-label={actionsLabel}
      sx={{ gridTemplateColumns: `repeat(${actionColumns}, minmax(0, 1fr))` }}>{actions}</Box>}
    {children}
  </article>;
}
